import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "PageEntitiesAndGeotargeting"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EntitiesAndGeotargeting = _resolveComponent("EntitiesAndGeotargeting", true)!

  return (!_ctx.isCampaignTypeCustomProducts)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_EntitiesAndGeotargeting)
      ]))
    : _createCommentVNode("v-if", true)
}